import { FileParameter } from "@core/models/file-upload/fileparameter";
import { TicketsModel } from "@core/services/api.service";


export class LoadLoggedTicketListAction {
    static readonly type = '[LoggedTickets] Load Logged Tickets';
}

export class LoadLoggedTicketSuccessAction {
    static readonly type = '[LoggedTickets] Load Logged Tickets Success';

    constructor(public payload: { tickets: TicketsModel[] }) { }
}

export class LoadLoggedTicketFailAction {
    static readonly type = '[LoggedTickets] Load Logged Tickets Fail';
}


//Create Ticket
export class CreateTicketAction {
    static readonly type = '[CreateTicket] Create Ticket';

    constructor(public payload: FormData) { }
}

export class CreateTicketSuccessAction {
    static readonly type = '[CreateTicket] Create Ticket Success';

    constructor(public payload: { ticket: TicketsModel }) { }
}

export class CreateTicketFailAction {
    static readonly type = '[CreateTicket] Create Ticket Fail';

    constructor(public error: any) { }
}
//end
